import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ForumSearchItem from './ForumSearchItem';

export default class ForumSearchBlock extends Component {
  static propTypes = {
    searchResult: PropTypes.array,
    searchQuery: PropTypes.string.isRequired,
  };

  render() {
    const { searchQuery, searchResult } = this.props;
    return (
      <div className="themes-search-result">
        <div className="themes-search-result__caption">{`Результат поиска «${searchQuery}»:`}</div>
        {searchResult && searchResult.length ? (
          searchResult.map((item, idx) => <ForumSearchItem key={idx} item={item} />)
        ) : (
          <div className="themes-search-result__big-message">
            <div className="big-message__main">По вашему запросу ничего не найдено</div>
            <div className="big-message__additional">Попробуйте изменить ключевое слово</div>
          </div>
        )}
      </div>
    );
  }
}
